// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"304df09b","88":"435ad87d","153":"e6cc78d4","258":"50ea6d7a","368":"b04989d2","704":"08d49eab","755":"769f8547","774":"6415c182","868":"84f9ff08","941":"97a59715"}[chunkId] + ".chunk.js";
};